import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import ResidueCategoriesList from './ResidueCategoriesList';

const ResidueCategory = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Categoría de Residuos' links={breadcrumbLinks} icon={'icon-trash-2'} />
					<ResidueCategoriesList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ResidueCategory;
